module.exports = __webpack_public_path__ + "img/组 11465.499fed1d.jpg";